module.exports = {
  pathPrefix: '',
  siteUrl: 'https://your-domain.com/',
  siteTitle: 'Muhammad Muneeb ur Rehman',
  siteDescription: 'Robotics engineer — digital twins, Sim2Real, UAV systems and reinforcement learning.',
  author: 'Muhammad Muneeb ur Rehman',
  postsForArchivePage: 3,
  defaultLanguage: 'en',
  disqusScript: process.env.DISQUS_SCRIPT || '',
  pages: {
    home: '/',
    blog: 'blog',
    contact: 'contact',
    services: 'services',
    resume: 'resume',
    tag: 'tags',
  },
  social: {
    github: 'https://github.com/munn33b',
    linkedin: 'https://www.linkedin.com/in/mun33b/',
    twitter: 'https://twitter.com/muneeb_isme',
    instagram: 'https://www.instagram.com/muneebisme/',
  },
  // Your own SMTP backend endpoint (see ./server). In production set this to
  // your deployed API, e.g. https://api.your-domain.com/api/contact
  contactFormUrl: process.env.CONTACT_FORM_ENDPOINT || 'https://muneebis.me/api/contact',
  orderFormUrl: process.env.ORDER_FORM_ENDPOINT || 'https://muneebis.me/api/order',
  googleAnalyticTrackingId: process.env.GA_TRACKING_ID || '',
  tags: {
    ros: {
      name: 'ROS',
      description: 'Robot Operating System (ROS / ROS 2) — the middleware powering perception, control and navigation stacks.',
      color: '#22314E',
    },
    sim: {
      name: 'Simulation',
      description: 'Gazebo / Ignition multi-physics simulation, digital twins and Sim2Real transfer.',
      color: '#0F8B8D',
    },
    python: {
      name: 'python',
      description: 'A general purpose language used for robotics tooling, ML and scripting.',
      color: '#f9c646',
    },
    cpp: {
      name: 'C++',
      description: 'Systems language used for performance-critical robotics and embedded code.',
      color: '#00599C',
    },
    ml: {
      name: 'Machine Learning',
      description: 'Reinforcement learning and computer vision for adaptive robotic behaviour.',
      color: '#FF6F00',
    },
    matlab: {
      name: 'MATLAB',
      description: 'Numerical computing used for modeling, control design and analysis.',
      color: '#E16737',
    },
    cad: {
      name: 'CAD',
      description: 'Mechanical design in SOLIDWORKS and CREO Parametric.',
      color: '#D62027',
    },
    embedded: {
      name: 'Embedded',
      description: 'Firmware on microcontrollers and flight controllers (ESP32, STM32, ARM Cortex).',
      color: '#E7352C',
    },
  },
};
